import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onBranchSelect = (selectedItems, selectedOption) => {
      setFiltersModel((prevState) => {
        return { ...prevState, branch_ids: [...(prevState.branch_ids || []), selectedOption.id] }
      })
    }
  
    const onBranchRemove = (selectedItems, removedOption) => {
      setFiltersModel((prevState) => {
        return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id)}
      })
    }

    const onServiceTypeSelect = (selectedItems, selectedOption) => {
      setFiltersModel((prevState) => {
        return { ...prevState, service_type_ids: [...(prevState.service_type_ids || []), selectedOption.id] }
      })
    }

    const onServiceTypeRemove = (selectedItems, removedOption) => {
      setFiltersModel((prevState) => {
        return { ...prevState, service_type_ids: prevState.service_type_ids.filter((id) => id !== removedOption.id) }
      })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
      <Form.Group className="mb-3">
        <Form.Label>Select Circle</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="branch_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "branches",
            dataAttr: "branches",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onBranchSelect}
          onRemove={onBranchRemove}
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Select Service Type</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="service_type_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "serviceType",
            dataAttr: "service_types",
            defaultFilters: { parent_ids: [1, 2] }
          }}
          labelAttr="name"
          valueAttr="id"
          displayValueAttr="parent_name"
          onSelect={onServiceTypeSelect}
          onRemove={onServiceTypeRemove}
        />
      </Form.Group>
    </Filters>
};

export default FiltersPartial;

